export const AVAILABLE_AI_FEATURES = [
	"fix-grammar",
	"improve",
	"translate",
	"rephrase",
	"catchy",
] as const

export type AvailableAiFeature = (typeof AVAILABLE_AI_FEATURES)[number]
